import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from 'fb';
import loginImage from 'assets/images/login_image3.jpg';

import { LoginBody } from './LoginBody';

export default function Login() {
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, user => {
            if (user) {
                // Navigate to home page
                navigate('/');
            }
        });

        // Cleanup subscription on unmount
        return () => unsubscribe();
    }, [navigate]);

    return (
        <center className='h-full'>
            <div className='h-full p-5 xl:max-w-screen-lg flex justify-center items-center gap-0 md:gap-6 lg:gap-12'>
                <div className="hidden flex-1 md:flex md:h-full md:flex-col md:justify-end bg-no-repeat bg-cover" style={{ maxHeight: 732, borderRadius: 4, overflow: 'hidden', backgroundImage: `url(${loginImage})` }}>
                    <div className='bg-gradient-to-t from-gray-600 to-transparent w-full p-6 text-white flex flex-col items-start'>
                        <span className="text-xl font-bold">1500+ Artists Onboard</span>
                        <span className="text-base font-medium">Register now</span>
                    </div>
                </div>
                <div className='flex-1'>
                    <LoginBody />
                </div>
            </div>
        </center>
    );
}